/**
 * @module location 
 *  Apis must need auth details to trigger url - AuthApi
 */

import Env from '@/env';
import NormalApis from '@/controllers/NormalApis';

export default {
   
    /**
     * Fetch by slug
     */
    insert(data) {
        const url = `${Env.checkinUrl}/checkIns`;
        return NormalApis.postApi(url, null, data)
        .then(res => res)
        .catch(err => err);
    },
    

}